export enum ModelType {
  Call = 'Call',
  Certificate = 'Certificate',
  Instance = 'Instance',
  Key = 'Key',
  Operation = 'Operation',
  OrganizationCertificate = 'OrganizationCertificate',
  OrganizationKey = 'OrganizationKey',
  Profile = 'Profile',
  Project = 'Project',
  ProjectException = 'ProjectException',
  Report = 'Report',
  ReportDone = 'ReportDone',
  ReportVulnerability = 'ReportVulnerability',
  Slot = 'Slot',
  Trace = 'Trace',
  User = 'User',
  Vulnerability = 'Vulnerability',
  Scan = 'Scan',
  ScanHost = 'ScanHost',
}

/**
 * Helper util class for encoding/decoding nodeIds from GQL queries
 */
export class GQLIdEncoder {
  /**
   * nodeId is a global encoded ID for gql
   * This is part of Node implementation for gql and we have them set as base64 encoded {type}:{id}
   * e.g. UHJvamVjdDoy === Project:2
   * To extract the real integer ID we need to decode the string split it by ':' where the second value is the
   * real ID
   */
  decode(nodeId: string): number {
    return parseInt(atob(nodeId).split(':')[1], 10);
  }

  /**
   * Converts id to encoded id for Node GQL implementation
   */
  encode(type: ModelType, id: number | string): string {
    return btoa(`${type}:${id}`);
  }
}
